import type {DatabagRouteMatch} from "../../routing/catRoutes";
import {routes} from "../../routing/routes";
import {environment} from "../../env";
import {generatePath} from "react-router";

export type Intent = {
    type: 'by_parent_supplier'
    supplier: string
}
export type UrlState = {
    searchIntent: Intent | null
}

const BY_SUPPLIER_VALUE = 's';

export function urlToIntent(urlParams: URLSearchParams): Intent | null {
    if (urlParams.has(BY_SUPPLIER_VALUE)) {
        return {
            type: 'by_parent_supplier',
            supplier: urlParams.get(BY_SUPPLIER_VALUE)!
        }
    }
    return null;
}

export function intentToURL(path: string, prevParams: URLSearchParams, intent: Intent): string {
    if (!path) return ''
    const params = new URLSearchParams(prevParams);

    if (intent.type === 'by_parent_supplier') {
        params.set(BY_SUPPLIER_VALUE, intent.supplier);
    }

    return path + '?' + params.toString()
}

export function buildPath(databagId: number) {
    if (environment.package !== 'cleanup') {
        console.warn('SupplierNormalizationUrls: buildPath called with non-cleanup package, this is not expected');
        return '';
    }
    const params: DatabagRouteMatch = {id: String(databagId)};
    return generatePath(routes.cleanup_supplier_normalization, params);
}
